import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../controls/contextMenu/models/MenuOptionType";
import type { DelayCategory } from "../models/CatalogCategory";

type Props = {
  setSelectedRowData: (category: DelayCategory) => void;
  setShowModal: (modal: "create" | "update" | "delete" | "") => void;
};

export const useCategoriesOptionsFunctions = ({
  setSelectedRowData,
  setShowModal,
}: Props) => {
  const getMenuOptions = (data: DelayCategory) => {
    let options: MenuOptionType[] = [];

    options = options.concat([
      {
        name: "New Category",
        key: "new_category",
        onClick: () => {
          setShowModal("create");
        },
        icon: <PlaylistAddIcon />,
      },
    ]);
    if (data) {
      options = options.concat([
        {
          name: "Edit Category",
          key: "edit_category",
          onClick: () => {
            setSelectedRowData(data);
            setShowModal("update");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Category",
          key: "delete_category",
          onClick: () => {
            setSelectedRowData(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
